<template>
  <div>
    <div
      class="top_img"
      :style="{ backgroundImage: 'url(' + list.background + ')' }"
    ></div>

    <div class="us_main ">
      <!-- 关于飞天 -->
      <div class="about_main ">
        <div class="content1">
          <div class="fl content1_top_right">
            <div class="img1">
              <img src="@/assets/images/tp.png" />
            </div>
          </div>
          <div class="fl content1_top_left ">
            <img src="@/assets/images/gyft_t.png" />
          </div>
          <img class="img2" src="@/assets/images/kjcz_x.png" />
          <!-- <img src="@/assets/images/us_t.png"/> -->
        </div>
        <div class="about_news f14" v-for="item in list.about.intro">
          {{ item }}
        </div>
      </div>

      <!--品牌文化  -->
      <div class="about_main  ">
        <div class="content2">
          <div class="content_top">
            <div class="fl">
              <img src="@/assets/images/ppwhbt.png" />
            </div>
            <div class="about_news f14 fr">
              {{ list.culture.intro }}
            </div>
          </div>
          <div class="content_bottom">
            <div v-for="(item, index) in list.culture.list" :class="top[index]">
              <p>{{ item.title }}</p>
              <span></span>
              <img :src="item.img" />
            </div>

            <img class="fr" src="@/assets/images/lgs.png" />
          </div>
        </div>
      </div>

      <!--产品流程  -->
      <div class="about_main center ">
        <img class="about_t_img" src="@/assets/images/lct1.png" />
        <div class="about_lc ">
          <ul>
            <li
              v-for="(item, index) in list.product.content"
              :style="{ 'border-color': list.col[index] }"
            >
              <div>
                <img class="img1" :src="item.img" />
                <img class="imgs" :src="item.imgs" />
              </div>
              <div>
                <p class="p2" v-for="items in item.p2">{{ items }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <!-- 部分四 -->
      <div class="content4">
        <!-- 轮播图 -->
        <div class="wrapper ">
          <img class="t_img" src="@/assets/images/ty_t1.png" />
          <p class="center gray f12">
            科技 · 创造 · 想象的理念，努力为树立行业旗帜而奋斗
          </p>

          <swiper :options="swiperOption" class="swiper-container">
            <swiper-slide
              class="swiper-item"
              v-for="item of list.banner"
              :key="item.id"
            >
              <img class="swiper-img" :src="item.img" alt="图片集" />
              <p class=" f14" v-html="item.title"></p>
            </swiper-slide>
          </swiper>

          <!-- 如果需要导航按钮 -->
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>

      <!-- 部分四 -->
      <!-- <div class="content4">
                                        <div class="wrapper ">
                                                <img class="t_img" src="@/assets/images/ty_t1.png" />
                                                <p class="center gray f12">科技 · 创造 · 想象的理念，努力为树立行业旗帜而奋斗</p>

                                                      <el-carousel indicator-position="none" :interval="3000" type="card" height="220px" arrow="never"  >
                                                        <el-carousel-item  v-for="item of list.banner"  :key="item.id" >
                                                               <div class="banner_img" >
                                                                  <img :src="item.img" alt="图片集"  />
                                                               </div>
                                                        </el-carousel-item>
                                                      </el-carousel>

                                        </div>

                                </div>  -->

      <!-- 联系我们 -->
      <div class="content5">
        <img class="t_img" src="@/assets/images/lxwm_t.png" />
        <p class="center gray f12 ">石家庄飞天科技开发有限公司</p>

        <div class="contact-us">
          <div class="contact-main">
            <img :src="listfoot.content1.img" />
            <a :href="'tel:' + listfoot.content1.content">
              <span v-html="listfoot.content1.content"></span
              ><span>（一键呼叫）</span>
            </a>
          </div>

          <div class="contact-main">
            <img :src="listfoot.content2.img" />
            <span v-html="listfoot.content2.content"></span>
          </div>

          <div class="contact-main">
            <img :src="listfoot.content3.img" />
            <a
              href="https://3gimg.qq.com/lightmap/v1/wxmarker/index.html?marker=coord:38.02430833025392,114.4639194570118;title:%E7%9F%B3%E5%AE%B6%E5%BA%84%E9%A3%9E%E5%A4%A9%E7%A7%91%E6%8A%80;addr:%E7%9F%B3%E5%AE%B6%E5%BA%84%E5%B8%82%E6%A7%90%E5%AE%89%E8%A5%BF%E8%B7%AF88%E5%8F%B7%E5%8D%93%E8%BE%BE%E4%B8%AD%E8%8B%91%E5%95%86%E5%8A%A1%E5%A4%A7%E5%8E%A6B%E5%BA%A7316&referer=wexinmp_profile"
            >
              <span v-html="listfoot.content3.content"></span
              ><span>（一键导航）</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import wxapi from "../../public/wxapi.js";
export default {
  data() {
    return {
      // 联系我们
      listfoot: {
        content1: {
          id: 1,
          img: require("@/assets/images/hhk1.png"),
          content: "0311-85048504"
        },
        content2: {
          id: 2,
          img: require("@/assets/images/hhk2.png"),
          content: "sjzftkj@126.com"
        },
        content3: {
          id: 3,
          img: require("@/assets/images/hhk3.png"),
          content: "河北省石家庄市长安区谈南路63号睿和中心商业写字楼1102"
        }
      },
      top: ["d1", "d2", "d3"],
      col: ["#1dbfbf", "#ffba59", "#30a2f2", "#ea68a2", "#3981e6", "#ec6b71"],
      swiperOption: {
        // pagination: {
        //         el: ".swiper-pagination",
        //         clickable: true // 允许点击小圆点跳转
        //         },
        slidesPerView: 3,
        spaceBetween: -200,
        centeredSlides: true,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        }, //自动播放
        speed: 1000, //滑动速度
        setWrapperSize: true,
        observeParents: true,
        paginationClickable: true, //点击分页器的指示点分页器控制Swiper切换
        loop: true, //循环
        observer: true,
        autoplayDisableOnInteraction: true //用户操作swiper之后，是否禁止autoplay
      },
      list: {
        background: require("@/assets/images/us_bg.png"),

        //
        about: {
          title: "石家庄飞天科技开发有限公司",
          intro: [
            "石家庄飞天科技开发有限公司致力于网站建设、微信营销、软件开发、品牌设计等服务。",
            "成立以来服务的客户有共青团河北省委、河北省地方金融监督管理局、石家庄市体育局、石家庄市应急管理局、石家庄市生态环境局、中国移动通信集团公司石家庄分公司、中共河北省委统战部、河北省残疾人联合会、衡水中铁建、建投·御湖园、河北超越健身等。公司拥有原创类软件系统十余套，在政府办公、事业单位、企业生产等领域得到了广泛的应用。",
            "“科技 · 创造 · 想象”，我们用先进的理念、专业的技术、优质的产品、贴心的服务为您创造价值，努力为树立行业旗帜而奋斗！"
          ],
          img1: require("@/assets/images/tp.png"),
          img2: require("@/assets/images/kjcz.png")
        },
        //
        culture: {
          title: "飞天品牌文化",
          img1: require("@/assets/images/ppwhbt.png"),
          intro:
            "品牌logo的创意来源于敦煌壁画形象、篆刻造型、中国航天等元素内容，结合了中国古代文化与现代科技的大美造型与含义。壁画中流云飞动，充满了欢乐、自由、祥和的气氛，表达了飞天文化崇尚自由、人性为本的理念。壁画与篆刻都凝聚了中华民族五千年的文化与智慧，充分体现了古人的动手创造能力。中国发展航天事业贯彻落实国家科技事业发展的指导方针，即自主创新、重点跨越、支撑发展、引领未来。这三个创意来源引出了飞天的核心理念科技、创造、想象。",
          list: [
            {
              title: "敦煌壁画",
              img: require("@/assets/images/gyl1.png")
            },
            {
              title: "篆刻造型",
              img: require("@/assets/images/gyl2.png")
            },
            {
              title: "中国航天",
              img: require("@/assets/images/gyl3.png")
            }
          ]
        },
        //
        col: ["#1dbfbf", "#ffba59", "#30a2f2", "#ea68a2", "#3981e6", "#ec6b71"],
        //
        product: {
          title: "产品流程",
          content: [
            {
              id: 1,
              img: require("@/assets/images/lc_1.png"),
              imgs: require("@/assets/images/num1.png"),
              p1: "需求沟通",
              p2: ["与客户进行沟通", "充分了解", "客户的需求"]
            },
            {
              id: 2,
              img: require("@/assets/images/lc_2.png"),
              imgs: require("@/assets/images/num2.png"),
              p1: "创意设计",
              p2: ["根据客户需求", "设计师构思", "进行产品设计"]
            },
            {
              id: 3,
              img: require("@/assets/images/lc_3.png"),
              imgs: require("@/assets/images/num3.png"),
              p1: "前端制作",
              p2: ["按照设计效果图", "前端程序", "实现显示效果"]
            },
            {
              id: 4,
              img: require("@/assets/images/lc_4.png"),
              imgs: require("@/assets/images/num4.png"),
              p1: "技术开发",
              p2: ["开发搭建后台", "与前端程序结合", "完成网站效果"]
            },
            {
              id: 5,
              img: require("@/assets/images/lc_5.png"),
              imgs: require("@/assets/images/num5.png"),
              p1: "测试调试",
              p2: ["进行试用和程序", "测试,完善", "产品功能效果"]
            },
            {
              id: 6,
              img: require("@/assets/images/lc_6.png"),
              imgs: require("@/assets/images/num6.png"),
              p1: "上线运行",
              p2: ["一切就绪", "交于客户,完成", "上线运行使用"]
            }
          ]
        },
        //
        banner: [
          // {
          //   img:require("@/assets/images/rys1.png"),
          //   title:"企业信用等级证书"
          // },

          {
            img: require("@/assets/images/rys3.jpg"),
            title: "河北省科技型中小企业"
          },
          {
            img: require("@/assets/images/rys4.png"),
            title: "营业执照"
          },
          {
            img: require("@/assets/images/rys5.jpg"),
            title: "全城热练智慧体育管理服务平台"
          },
          {
            img: require("@/assets/images/rys6.jpg"),
            title: "危险化学品安全体系建设管理追溯系统"
          },
          {
            img: require("@/assets/images/rys7.jpg"),
            title: "环保易巡检管理系统"
          },

          // {
          //   img:require("@/assets/images/rys2.png"),
          //   title:"9000质量管理体系认证证书"
          // },
          // {
          //   img:require("@/assets/images/rys1.png"),
          //   title:"企业信用等级证书"
          // },
          //
          // {
          //   img:require("@/assets/images/rys3.jpg"),
          //   title:"河北省科技型中小企业"
          // },
          // {
          //   img:require("@/assets/images/rys4.png"),
          //   title:"营业执照"
          // },
          //
          // {
          //   img:require("@/assets/images/rys2.png"),
          //   title:"9000质量管理体系认证证书"
          // },
          //

        ],
      }
    };
  },
  methods: {
    // 分享
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: "联系我们", // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
        //   alert("分享成功");
        },
        error: () => {
        //   alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: "联系我们", // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
        //   alert("分享成功");
        },
        error: () => {
        //   alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
    async getfoot() {
      var that = this;
      var dt = await this.$axios.get("/api/footer");

      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      that.listfoot.contact = dt.data.data.abouts;
    }
  },

  mounted() {
    window.scrollTo(0, document.body.scrollHeight);
    wxapi.wxRegister(this.wxRegCallback);
  }
};
</script>

<style lang="less" scoped>
.top_img {
  background-size: 100% 100%;
  height: 140px;
  top: 0;
  left: 0;
}

.us_main {
  margin: -150px 0 0px;
  padding: 50px 0 0;
  top: 0;
  left: 0;
  width: 100%;

  .us_title {
    padding: 0 0 20px;

    .p1 {
      line-height: 50px;
      font-size: 20px;
      position: relative;
      margin-bottom: 10px;
    }

    .p1::after {
      content: "";
      position: absolute;
      height: 2px;
      background: #fff;
      width: 10%;
      left: 45%;
      bottom: 0;
    }
  }

  .about_main {
    background: #fff;
    padding: 20px 10px;
    margin: 10px;
    border-radius: 5px;
    overflow: hidden;

    .about_t_img {
      width: 210px;
      margin-bottom: 20px;
    }
    .content1 {
      overflow: hidden;
      padding-bottom: 10px;
      max-width: 410px;
      margin: 0 auto;
      .img1 {
        /* width: 140px; */
        width: 100%;
        overflow: hidden;
        height: 115px;

        img {
          width: 100%;
          margin-top: -20px;
        }
      }

      .img2 {
        width: 280px;
        float: right;
        margin-top: -25px;
      }

      .content1_top_right {
        width: 43%;
      }
      .content1_top_left {
        padding-top: 15px;
        /* margin-left: 15px; */
        float: right;
        width: 52%;
        img {
          /* width: 180px; */
          width: 100%;
        }
      }
      .fr {
        p {
          font-style: italic;
          display: flex;
          align-items: center;
          padding: 10px 0px 10px 15px;

          img {
            width: 40px;
            margin-left: 10px;
          }
        }

        /* .about_bottom{
                                text-indent: 2em;
                                padding: 15px 0;
                                border-top: 2px solid #e50012;
                                line-height: 45px;
                                } */
      }
    }

    .content2 {
      .content_top {
        overflow: hidden;
        display: flex;
        .fl {
          img {
            margin-top: 5px;
            width: 45px;
          }
        }
        .fr {
          padding-left: 20px;
        }
      }

      .content_bottom {
        position: relative;
        height: 250px;
        width: 100%;
        font-size: 14px;
        max-width: 400px;
        margin: 0 auto;
        .d1 {
          top: 25px;
          left: 50px;
        }

        .d2 {
          top: 105px;
          left: 20px;
        }

        .d3 {
          top: 185px;
          left: 50px;
        }

        div {
          position: absolute;
          width: 150px;
          display: flex;
          align-items: center;

          span {
            transition: all 0.5s;
            width: 6px;
            height: 6px;
            background: #e71122;
            border-radius: 100%;
            margin: 0 10px 0 10px;
          }

          img {
            width: 60px;
            transition: all 0.5s;
          }

          p {
            color: #e71122;
            width: auto;
            font-size: 12px;
          }
        }

        .fr {
          position: absolute;
          top: 70px;
          right: 15px;
          width: 140px;
        }
      }
    }

    .about_tit {
      display: inline-block;
      height: 40px;
      padding: 0 25px;
      background-image: url("../../assets/images/hk1.png");
      background-size: 100% 100%;
      margin-bottom: 15px;

      p {
        padding-top: 4px;
      }
    }

    .about_tit2 {
      background-image: url("../../assets/images/hk2.png");
    }

    .about_tit3 {
      background-image: url("../../assets/images/hk3.png");
    }

    .about_news {
      text-align: left;
      line-height: 25px;
      text-indent: 2em;

      img {
        max-width: 90%;
        margin: 20px auto;
        display: block;
      }

      .img_div {
        text-align: center;
        img {
          max-width: 95%;
          margin: 20px auto;
        }
      }
    }

    .about_lc {
      background: #f2f2f2;
      padding: 10px;
      border-radius: 5px;
      ul {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        overflow: hidden;
        flex-flow: row wrap;

        li {
          background: #fff;
          border-style: solid;
          border-width: 1px;
          display: block;
          float: left;
          padding: 5px;
          box-sizing: border-box;
          border-radius: 5px;
          overflow: hidden;
          width: 32%;
          margin: 1% 0;

          .p1 {
            line-height: 30px;
          }
          .p2 {
            font-size: 12px;
            line-height: 22px;
          }

          .img1 {
            width: 45px;
            margin: 5px auto;
            display: block;
          }

          .imgs {
            width: 50px;
            display: block;
            margin: 5px auto;
          }
        }
      }
    }
  }

  .content4 {
    /* background: url(../../assets/images/ryzsbj.png); */
    background-size: 100% 100%;
    background-position: top left;
    overflow: hidden;
    margin-bottom: 10px;
    /* height: 635px; */

    .content4_top {
      img {
        width: 405px;
        margin: 80px auto 30px;
        display: block;
      }
    }

    /* .wrapper {
                                padding-top: 30px;
                                border-radius: 5px;
                                position: relative;
                                background: #fff;
                                margin:0 10px;
                                overflow: hidden;
                                p{
                                 margin: 10px 0;
                                }

                                .t_img{
                                        display: block;
                                        width: 200px;
                                        margin: 0 auto;
                                }
                                /deep/ .el-carousel{

                                        overflow: hidden;
                                        margin: 0 auto 20px;
                                        width:95%;
                                                .el-carousel__item{

                                                                height:220px;
                                                                overflow: hidden;
                                                                display: flex;
                                                                justify-content: center;
                                                                align-items: center;
                                                                .banner_img{
                                                                       img{
                                                                        width: 100%;
                                                                        max-height:120px;
                                                                        border-radius: 5px;
                                                                        border: 6px solid #f2f2f2;
                                                                        box-sizing: border-box;
                                                                       }
                                                                }
                                                        }

                                                .is-active{
                                                                height:220px ;
                                                                margin: 0 auto;
                                                                .banner_img{
                                                                        img{
                                                                                max-width: 100%;
                                                                                max-height: 220px;
                                                                        }
                                                                }
                                                        }
                                 }


                } */
    .wrapper {
      padding-top: 30px;
      border-radius: 5px;
      position: relative;
      background: #fff;
      margin: 0 10px;
      p {
        margin: 10px 0;
      }

      .t_img {
        display: block;
        width: 200px;
        margin: 0 auto;
      }
      .swiper-item {
        opacity: 0;
        transform: scale(0.8);
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column !important;
        padding: 0;
        height: 220px;

        img {
          display: block;
          border: 10px solid #f2f2f2;
          border-radius: 5px;
        }

        p {
          display: block;
          overflow: hidden;
        }
      }
      .swiper-slide-active {
        transition: transform 0.4s ease-in-out,
          -webkit-transform 0.4s ease-in-out;
        opacity: 1 !important;
        z-index: 999 !important;
        transform: scale(1) !important;

        .swiper-img {
          z-index: 9999;
          opacity: 1;
          max-height: 180px;
          margin: 0 auto;
          max-width: 90%;
        }

        img {
          max-height: 160px !important;
        }
      }

      .swiper-slide-prev {
        transition: transform 0.5s ease-in-out;
        opacity: 0.5 !important;
        z-index: 2;
        img {
          height: 160px !important;
          width: 100%;
        }

        p {
          opacity: 0;
        }
      }
      .swiper-slide-next {
        transition: transform 0.5s ease-in-out;
        opacity: 0.5 !important;
        z-index: 2;
        img {
          height: 160px !important;
          width: 100%;
        }

        p {
          opacity: 0;
        }
      }
      .swiper-slide {
        text-align: center;
      }

      .swiper-button-next {
        background: url(../../assets/images/ban_r.png);
        right: -40px;
        outline: none;
      }

      .swiper-button-prev {
        background: url(../../assets/images/ban_l.png);
        left: -40px;
        outline: none;
      }
    }
  }

  .content5 {
    padding: 30px 0 20px;
    border-radius: 5px;
    position: relative;
    background: #fff;
    margin: 0 10px;
    overflow: hidden;

    .t_img {
      display: block;
      width: 200px;
      margin: 0 auto;
    }

    p {
      margin: 10px 0;
    }
    .contact-main {
      line-height: 30px;
      font-size: 14px;
      padding: 0 10px;
      /* display: flex;
                        align-items: center; */

      img {
        max-width: 15px;
        margin-right: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/move/us.vue